import React, { FC } from 'react'

// TODO: replace with pixel button props when types get included
import type { ButtonProps } from '@mui/material/Button'
import Button from '@pixel/core/Button'
import { LocalizedText } from '../contexts/Localization/LocalizationTypes'
import { useLocalizedText } from '../contexts/Localization/localizationHooks'

interface LocalizedButtonProps extends ButtonProps {
    text: LocalizedText
}
export const LocalizedButton: FC<LocalizedButtonProps> = ({
    text,
    ...props
}) => {
    const textValue = useLocalizedText(text)

    return (
        <Button {...props}>{textValue}</Button>
    )
}

export default LocalizedButton
